import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class EstimateMappingService {

  constructor(private http: HttpClient) {}

  loadJsonObject(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveMapping(
    baseUrl: string,
    mappingData: any,
    isDelete: boolean,
    isEdit: boolean,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=l8udm4`;
    const payload = _.extend({}, mappingData, { isDelete, isEdit });
    const jsonSettings = JSON.stringify({
      tax_year: filterParams?.tax_year ?? globalService?.tax_year,
      sso_id: globalService?.sso_id
    });
    let params: any = _.merge({}, globalService?.globalParams ?? globalService ?? {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(payload) }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    params.process_name = 'est-mapping-save';
    params.scenarioCode = 'EST';
    params.is_issue_key_enabled = 'N';
    params.jcd_key = globalService?.jcd_key ?? filterParams?.jcd_key ?? 250;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
